"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Day = function Day(_ref) {
  var dateIndex = _ref.dateIndex,
      dateValue = _ref.dateValue,
      selected = _ref.selected,
      hovered = _ref.hovered,
      disabled = _ref.disabled,
      onSelectDate = _ref.onSelectDate,
      onHoverDate = _ref.onHoverDate,
      isEndDay = _ref.isEndDay,
      totalDay = _ref.totalDay,
      highlight = _ref.highlight;

  function selectDate(e) {
    e.stopPropagation();
    e.preventDefault();
    if (disabled) return;
    onSelectDate(dateValue);
  }

  function handleHoverDate() {
    if (disabled || !onHoverDate) return;
    onHoverDate(dateValue);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('day', {
      selected: selected,
      hovered: hovered,
      disabled: disabled,
      highlight: highlight,
      end: isEndDay
    }),
    onClick: selectDate,
    onMouseEnter: handleHoverDate,
    role: "button",
    tabIndex: "-1",
    "data-day-index": dateIndex,
    "data-date-value": dateValue
  }, hovered && !(isEndDay && dateIndex === totalDay) && !(dateIndex === 1 && selected && !isEndDay) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('background-day', {
      'first-day': dateIndex === 1,
      'last-day': dateIndex === totalDay
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-day"
  }, dateIndex));
};

Day.propTypes = {
  dateIndex: _propTypes.default.number,
  dateValue: _propTypes.default.string,
  isEndDay: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  hovered: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onSelectDate: _propTypes.default.func,
  onHoverDate: _propTypes.default.func,
  totalDay: _propTypes.default.number,
  highlight: _propTypes.default.bool
};
Day.defaultProps = {
  dateIndex: null,
  dateValue: null,
  isEndDay: false,
  selected: false,
  hovered: false,
  disabled: false,
  totalDay: null,
  onSelectDate: function onSelectDate() {},
  onHoverDate: function onHoverDate() {},
  highlight: false
};
var _default = Day;
exports.default = _default;